








import { Component, Prop, Vue } from 'vue-property-decorator'
import { GameState } from '@/enum'
import { GamePlayer } from '@/class/gamePlayer'
import Card from '@/components/Common/Card/Card.vue'

@Component({
  components: {
    Card
  }
})
export default class FirstNight extends Vue {
  @Prop() playerSelf!: GamePlayer;

  get firstNightActionFollowMessage () {
    if (this.playerSelf.role.activeIn[GameState.firstNight]) {
      return this.playerSelf.role.nightActionFollowMessage
    } else {
      return '怪しいと思う人物を一人選んでください。'
    }
  }
}
